import api from './api';

export const createBackup = (options) => api.post('/backups', options);
export const getBackups = (params) => api.get('/backups', { params });
export const getBackup = (id) => api.get(`/backups/${id}`);
export const downloadBackup = (id) => api.get(`/backups/${id}/download`, { responseType: 'blob' });
export const restoreBackup = (id, options) => api.post(`/backups/${id}/restore`, options);
export const deleteBackup = (id) => api.delete(`/backups/${id}`);
export const getBackupSettings = () => api.get('/backups/settings');
export const updateBackupSettings = (settings) => api.put('/backups/settings', settings);
export const testEmail = () => api.post('/backups/settings/test-email');
export const testCloud = () => api.post('/backups/settings/test-cloud');
export const getBackupSchedule = () => api.get('/backups/schedule');
export const updateBackupSchedule = (schedule) => api.put('/backups/schedule', schedule);
export const getBackupStatus = () => api.get('/backups/status');
